<template>
    <div>
        <breadcrumb
            class="mt-4"
            :links="[{ msg: 'purchased.order.history' }]"
        />
        <div class="my-8 flex justify-center" v-if="loading">
            <spinner />
        </div>
        <template v-else>
            <h3 class="section-title mb-4">
                {{ $t('purchased.order.history') }}
            </h3>
            <div
                v-if="!confirmedOrderProductList.length"
                class="w-full text-center text-2xl pt-4"
            >
                {{ $t('order.no.order.history') }}
            </div>
            <div v-for="(g, gi) in groups" :key="gi">
                <template
                    v-if="
                        distinctProductListInMonth(g.startMonth, g.endMonth)
                            .length
                    "
                >
                    <div class="font-bold text-lg sm:text-2xl">
                        {{ $t(g.groupName) }}
                    </div>
                    <div class="flex flex-wrap -mx-4 mb-16">
                        <div
                            v-for="(p, pi) in distinctProductListInMonth(
                                g.startMonth,
                                g.endMonth
                            )"
                            :key="pi"
                            class="flex flex-col px-4 py-8 lg:px-8 w-1/2 lg:w-1/4"
                        >
                            <router-link
                                :to="{
                                    name: 'purchasedProductInfo',
                                    params: {
                                        prodId: p.prodId
                                    }
                                }"
                            >
                                <div class="relative">
                                    <productImage
                                        imageType="small"
                                        :product="p"
                                    />
                                </div>
                                <div>
                                    {{ p.prodBrndName }}
                                </div>
                                <contentNewLine
                                    v-if="$config.showProdName"
                                    class="font-bold  py-1"
                                    :value="p.prodName"
                                />
                                <div class="text-sm">
                                    {{ p.prodSizeText }}
                                </div>
                            </router-link>
                        </div>
                    </div>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb.vue';
import spinner from '@/components/spinner.vue';
import differenceInMonths from 'date-fns/differenceInMonths';
import uniqBy from 'lodash/uniqBy';
import productImage from '@/components/productImage.vue';
import contentNewLine from '@/components/contentNewLine';

export default {
    components: {
        breadcrumb,
        spinner,
        productImage,
        contentNewLine
    },
    data() {
        return {
            loading: true,
            groups: [
                {
                    groupName: 'purchased.order.period.1m',
                    startMonth: 0,
                    endMonth: 1
                },
                {
                    groupName: 'purchased.order.period.1m.to.3m',
                    startMonth: 1,
                    endMonth: 3
                },
                {
                    groupName: 'purchased.order.period.3m.to.6m',
                    startMonth: 3,
                    endMonth: 6
                },
                {
                    groupName: 'purchased.order.period.6m',
                    startMonth: 6,
                    endMonth: Number.MAX_SAFE_INTEGER
                }
            ]
        };
    },
    async mounted() {
        this.loading = true;
        if (!this.$store.state.orderList || !this.$store.state.orderList.length)
            await this.$store.dispatch('loadOrderList');
        this.loading = false;
    },
    methods: {
        confirmedOrderProductListInMouths(startMonth, endMonth) {
            return this.confirmedOrderProductList.filter(p => {
                const monthDiff = differenceInMonths(
                    new Date(),
                    new Date(p.saleOrdCreDate)
                );
                return monthDiff >= startMonth && monthDiff < endMonth;
            });
        },
        distinctProducts(saleOrdProdList) {
            const uniqProductList = uniqBy(saleOrdProdList, 'prodKey').map(
                p => ({
                    ...p,
                    id: p.prodKey
                })
            );

            return uniqProductList;
        },
        distinctProductListInMonth(startMonth, endMonth) {
            return this.distinctProducts(
                this.confirmedOrderProductListInMouths(startMonth, endMonth)
            );
        }
    },
    computed: {
        list() {
            return this.$store.getters.purchasedProductList;
        },
        confirmedOrderProductList() {
            return this.$store.getters.confirmedOrderProductList;
        }
    }
};
</script>
